import React, { useMemo } from 'react';
import useColors from 'hooks/useColors';
import { View } from 'react-native';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { selectSpaceInfoById } from 'features/spaces/reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { Avatar } from './avatar/Avatar';
import { rem } from './values';
import Text from './Text';
export const SpaceUserAvatar = ({ userId, spaceId, xxSmall, xSmall, customText, style }) => {
    const spaceInfo = useAppSelector((store) => selectSpaceInfoById(store, spaceId));
    const user = useMemo(() => {
        if (!spaceInfo)
            return undefined;
        const { users } = spaceInfo;
        return users?.find((user) => user.id === userId);
    }, [spaceInfo, userId]);
    const { firstName, lastName, imageUrl, size } = useMemo(() => ({
        ...user,
        size: xxSmall ? rem(18) : rem(24),
    }), [user, xxSmall]);
    const colors = useColors();
    const styles = useStyles(styleSet);
    if (!firstName || !user || !spaceInfo?.users || spaceInfo?.users.length < 2)
        return null;
    return (<View style={[styles.container, style]}>
      <Avatar name={firstName} lastName={lastName} size={size} color={colors.background.brandLight} borderWidth={1} fontColor={colors.text.textOnBrand} imageUrl={imageUrl} style={styles.extraSmallAvatar} xSmall={xSmall} xxSmall={xxSmall}/>
      <Text TextThin-14 Secondary>
        {firstName}
        {!!customText && (<Text TextThin-14 Secondary>
            {customText}
          </Text>)}
      </Text>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    extraSmallAvatar: {
        marginRight: rem(8),
        marginVertical: rem(1),
    },
}));
